import { CatalogRegistration } from '@/redux/modules/catalog/registration/catalogRegistration.types';
import { AnalyticsCatalogRegistrationStatus } from '@/utils/amplitude/analytics/core.types';

export const getAnalyticsRegistrationStatus = (status: CatalogRegistration): AnalyticsCatalogRegistrationStatus => {
    if (status.limited) {
        return AnalyticsCatalogRegistrationStatus.ApprovedWithLimit;
    }
    if (status.approved) {
        return AnalyticsCatalogRegistrationStatus.Approved;
    }
    if (status.declined) {
        return AnalyticsCatalogRegistrationStatus.Declined;
    }
    if (status.pending) {
        return AnalyticsCatalogRegistrationStatus.Pending;
    }
    return AnalyticsCatalogRegistrationStatus.NotRegistered;
};
